import React from 'react';

import { Box, IconButton } from '@mui/material';
import PropTypes from 'prop-types';

import { SECONDARY_COLOR } from 'constants/ui';

import AddRemoveIcon from '../AddRemoveIcon';
import { ADD_REMOVE_ICON_TYPE } from '../AddRemoveIcon/AddRemoveIcon.constants';

import { buttonStyles, getWrapperStyles } from './ListControls.styles';
import { ListControlsTestIds } from './ListControls.testIds';

const ListControls = ({
  isAddVisible = true,
  isRemoveVisible = true,
  isAddDisabled = false,
  isRemoveDisabled = false,
  onAdd,
  onRemove,
  color = SECONDARY_COLOR,
  customStyles,
}) => (
  <Box sx={getWrapperStyles(customStyles)}>
    {isAddVisible && (
      <IconButton
        disableRipple
        className="button button_add"
        data-testid={ListControlsTestIds.ADD_BUTTON}
        disabled={isAddDisabled}
        sx={buttonStyles}
        onClick={onAdd}
      >
        <AddRemoveIcon color={color} height={16} width={16} />
      </IconButton>
    )}
    {isRemoveVisible && (
      <IconButton
        className="button button_remove"
        data-testid={ListControlsTestIds.REMOVE_BUTTON}
        disabled={isRemoveDisabled}
        sx={buttonStyles}
        onClick={onRemove}
      >
        <AddRemoveIcon color={color} height={16} type={ADD_REMOVE_ICON_TYPE.REMOVE} width={16} />
      </IconButton>
    )}
  </Box>
);

ListControls.propTypes = {
  color: PropTypes.string,
  customStyles: PropTypes.object,
  isAddDisabled: PropTypes.bool,
  isAddVisible: PropTypes.bool,
  isRemoveDisabled: PropTypes.bool,
  isRemoveVisible: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

export default ListControls;
